'use client';

interface ErrorProps {
  error: Error & { digest?: string };
  reset: () => void;
}

// 노션 조회 실패 시의 에러 바운더리.
// page.tsx는 조회 실패를 404로 바꾸지 않고 예외로 던진다(404로 처리하면 일시적 장애가
// ISR 캐시에 굳는다). 그 예외를 여기서 받아 재시도 가능한 화면으로 보여준다.
export default function NotionAppError({ error, reset }: ErrorProps) {
  return (
    <div className="flex min-h-dvh flex-col items-center justify-center gap-5 px-6">
      <p className="text-center text-xl leading-relaxed font-bold">
        페이지를 불러오지 못했습니다.
        <br />
        잠시 후 다시 시도해주세요.
      </p>
      <button
        type="button"
        onClick={reset}
        className="h-11 w-80 max-w-full cursor-pointer rounded-full border border-black bg-white text-sm font-extrabold text-black hover:bg-neutral-100"
      >
        다시 시도
      </button>
      {process.env.NEXT_PUBLIC_MODE === 'development' && (
        <pre className="max-w-full overflow-auto rounded bg-black/5 p-3 text-xs text-black/50">{error.message}</pre>
      )}
    </div>
  );
}
